import React, { useState, useContext, useEffect } from "react";
import "./filter.css";
import Dropdown from "react-bootstrap/Dropdown";
import { AiOutlineUnorderedList } from "react-icons/ai";
import { BiGrid } from "react-icons/bi";
import { NavLink } from "react-router-dom";
import { BiSearch } from "react-icons/bi";
import Accordion from "react-bootstrap/Accordion";
import { FaAngleDown } from "react-icons/fa";
import Form from "react-bootstrap/Form";
import { AiFillStar } from "react-icons/ai";
import SearchContext from "../../context/SearchContext";
import FilterRating from "../filterRating/FilterRating";
import { baseUrl } from "../../context/BaseUrl";

const VacancyShort = ({ handle, sortHandle, catHandle }) => {
  const [result, setResult] = useState(false);
  const [options, setOptions] = useState([]);
  const { search, setSearch } = handle;
  const { category, setCategory } = catHandle;
  const { sort, setSort } = sortHandle;

  const [show, setShow] = useState(false);

  const fetchCategories = async () => {
    const response = await fetch(`${baseUrl}/admin/vacancy/get`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });

    const result = await response.json();

    console.log("categories", result);
    setOptions(result);
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  return (
    <>
      <div className="d-flex PC-filter vacancyshort flex-column flex-sm-row align-items-end">
        <div className="left">
          <button className="filt-btn" onClick={() => setShow(!show)}>
            {" "}
            Filters <FaAngleDown />{" "}
          </button>
          {show && (<>
                        <div className="popupbg" onClick={() => setShow(!show)}></div>

            <div className="filt-content">
              <h5>Filters</h5>
              <Accordion>
                <Accordion.Item eventKey="0">
                  <Accordion.Header>Category</Accordion.Header>
                  <Accordion.Body>
                    <Form>
                      <Form.Select
                        className="mb-3"
                        onChange={(e) => setCategory(e.target.value)}
                      >
                        <option value="">Select Category</option>
                        {options.map((item) => (
                          <option value={item.name}>
                            {item.name.toUpperCase()}
                          </option>
                        ))}
                      </Form.Select>
                    </Form>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div></>
          )}
          <div className="search">
            <input
              placeholder="search.."
              className="w-100"
              type="text"
              value={search}
              onInput={(e) => setSearch(e.target.value)}
            />
            <span>
              <BiSearch />
            </span>
            {result && (
              <React.Fragment>
                <div className="floatingSearch">
                  {result.institute.map((el) => {
                    return (
                      <div>
                        <NavLink
                          variant="primary"
                          className={"link"}
                          to={`/institute/${el.institute_id}`}
                          style={({ isActive }) => ({
                            color: "#00f",
                            padding: "5px 10px",
                          })}
                        >
                          {el.name}
                        </NavLink>
                      </div>
                    );
                  })}
                  {result.course_list.map((el) => {
                    return (
                      <div>
                        <NavLink
                          variant="primary"
                          className={"link"}
                          to={`/course/${el._id}`}
                          style={({ isActive }) => ({
                            color: "#00f",
                            padding: "5px 10px",
                          })}
                        >
                          {el.course}
                        </NavLink>
                      </div>
                    );
                  })}
                  {result.vacancy.map((el) => {
                    return (
                      <div>
                        <NavLink
                          variant="primary"
                          className={"link"}
                          to={`/vacancy-detail/${el._id}`}
                          style={({ isActive }) => ({
                            color: "#00f",
                            padding: "5px 10px",
                          })}
                        >
                          {el.name}
                        </NavLink>
                      </div>
                    );
                  })}
                </div>
              </React.Fragment>
            )}
          </div>
        </div>

        <div className="right mt-4">
          <div className="d-lg-inline-block  d-none dropdown me-0 nav-link-lg text-decoration-none">
            <span className="text-nowrap"> Sort by </span>
            <Form.Select
              aria-label="Default select example"
              onChange={(e) => setSort(e.target.value)}
            >
              <option className="" value={""}>
                Select---
              </option>
              <option value="namea">Name (A - Z)</option>
              <option value="named">Name (Z - A)</option>
              <option value="latest">Latest</option>
              <option value="oldest">Oldest</option>
            </Form.Select>
          </div>
        </div>
      </div>
    </>
  );
};

export default VacancyShort;
